import config from '@/config/config.js';
import { http } from '@/common/request';
import errorCode from '@/api/error-code.js'
export default {
    /***************************************************** start *******************************************/

    getRegions(){
        let data = {
        }
        return  http.request({url:"/api/v3/common/address/getRegions",data, method: 'GET'});
    },


    getCountries(){
        let data = {
        }
        return  http.request({url:"/api/v3/common/address/getCountries",data, method: 'GET'});
    },


    getStates(countryId){
        let params = {countryId: countryId}
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/common/address/getStates",data, method: 'GET', ...options});
    },

    getCities(stateId){
        let params = {stateId: stateId}
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/common/address/getCities",data, method: 'GET', ...options});
    },








    /***************************************************** end *********************************************/
}
